// extracted by mini-css-extract-plugin
module.exports = {"photosWrapper":"PhotosWrapper_photosWrapper__1bO5h","title":"PhotosWrapper_title__dQtyx"};